document.addEventListener("DOMContentLoaded", (event) => {
    window.jQuery(function($) {
        $('.reviews__grid--slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            touchThreshold: 100,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            infinite: true,
            speed: 2500,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '40px'
                    }
                },
            ]
        });
    });
});





